import appsPreviewImage from '~/assets/images/builder/defaultPreview/apps.png';
import couponPreviewImage from '~/assets/images/builder/defaultPreview/coupon.png';
import imagesPreviewImage from '~/assets/images/builder/defaultPreview/images.png';
import listOfLinksPreviewImage from '~/assets/images/builder/defaultPreview/list-of-links.png';
import pdfPreviewImage from '~/assets/images/builder/defaultPreview/pdf.png';
import socialPreviewImage from '~/assets/images/builder/defaultPreview/social.png';
import vCardPlusPreviewImage from '~/assets/images/builder/defaultPreview/vCardPlus.png';
import videoPreviewImage from '~/assets/images/builder/defaultPreview/video.png';
import websitePreviewImage from '~/assets/images/builder/defaultPreview/website.png';
import previewExample from '~/assets/images/preview-example.png';
import { QRCODE_DYNAMIC_MICROSITE_TYPE } from '~/constants/qr-code';
import useBuilderStore from '~/store/useBuilderStore';

export const InitialEmptyScreen = () => {
  const { selectQrTypeHovered } = useBuilderStore();

  const getImage = () => {
    switch (selectQrTypeHovered) {
      case QRCODE_DYNAMIC_MICROSITE_TYPE.IMAGES:
        return imagesPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.PDF:
        return pdfPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.LINKS:
        return listOfLinksPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.APP:
        return appsPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.VCARD_PLUS:
        return vCardPlusPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.SOCIAL_MEDIA:
        return socialPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON:
        return couponPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.VIDEO:
        return videoPreviewImage;
      case QRCODE_DYNAMIC_MICROSITE_TYPE.WEBSITE:
        return websitePreviewImage;
      default:
        return previewExample;
    }
  };

  return <img src={getImage()} alt="preview example" width={278} />;
};
